export const ObjectTypeIdName = {
  1: 'квартиры',
  2: 'дома',
  3: 'коммерческого помещения',
};
